import { Formik } from "formik";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { showErrorNotification } from "../../../customHooks";
import { dateConvertTo_YYYY_MM_DD } from "../../../utils/CommonFunction";
import FormikControl from "../../formikcontrols";
import "./DateFilter.scss";
//import { statusToggleFunc } from '../../customHooks';
//import './SearchHeader.scss'
//const SearchHeader = ({title,openModal,getSearchValue,setPageNo,searchDate}) => {}

var maxDate = new Date().toISOString().slice(0, 10);
const DateFilter = ({
  isDateOpen,
  closeDateFilter,
  dateData,
  setIscondition,
  setGetDate,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [date, setDate] = useState({ from: "", to: "" });

  const handleDate = async (e) => {
    let { name, value } = e.target;
    setDate({ ...date, [name]: value });
  };

  const handledateSubmit = () => {
    try {
      setGetDate(date);
      setIscondition(true);
      closeDateFilter();
    } catch (error) {
      showErrorNotification(error.response.data.message);
    }
  };

  return (
    <Formik>
      <div className="modal">
        <Modal
          show={isDateOpen}
          onHide={closeDateFilter}
          centered={true}
          animation={false}
          size="sm"
        >
          <Modal.Body className="modal__body">
            {/* <FormikControl
        control ="date"
        label="From"
         name="from"/>  */}
            <table>
              <tbody>
                <tr>
                  <td>
                    <label className="lable1">Start Date</label>
                  </td>
                  <td>
                    <span className="lable1">: </span>
                    <input
                      type="date"
                      onChange={handleDate}
                      min="2000-01-01"
                      max={maxDate}
                      value={date.from}
                      name="from"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label className="lable1">End Date</label>
                  </td>
                  <td>
                    <span className="lable1">: </span>
                    <input
                      type="date"
                      disabled={date.from == ""}
                      min="2000-01-01"
                      max={maxDate}
                      onChange={handleDate}
                      value={date.to}
                      name="to"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            {/* <FormikControl
        control ="date"
        label="To"
        name="to"/>   */}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="modal_btn1_search"
              onClick={handledateSubmit}
              disabled={date.from == "" && date.to == ""}
            >
              Search
            </button>

            <input
              type="button"
              className="modal_btn2_close"
              value="Cancel"
              onClick={closeDateFilter}
            />
          </Modal.Footer>
        </Modal>
      </div>
    </Formik>
  );
};

export default DateFilter;
